<template>
  <div class="popup-contain">
    <!-- For add appointment page -->
    <div
      class="save-event-contain"
      v-if="$router.history.current.fullPath !== '/contacts'"
    >
      <p>How would you like to save?</p>
      <div class="save-this-event" @click.prevent.stop="addPersonLocal(true)">
        Save for this appointment only
      </div>
      <div
        class="save-future-event"
        @click.prevent.stop="addPersonLocal(false)"
      >
        Save For Future
      </div>
    </div>

    <!-- For contacts -->
    <div class="save-event-contain" v-else>
      <div
        class="save-future-event"
        @click.prevent.stop="addPersonLocal(false)"
      >
        Click to confirm
      </div>
    </div>
    <div class="cancel-contain" @click.stop.prevent="hide">Cancel</div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    hide: Function, // Method to hide popup
    additionalFunction: {
      default: () => {},
      type: Function
    }
  },
  methods: {
    ...mapActions("person", {
      addPerson: "addPerson"
    }),
    addPersonLocal(value) {
      this.hide();
      this.addPerson(value).then(added => {
        if (added) {
          this.additionalFunction();
        }
      });
    }
  },
  created() {
    window.pell = this.$router;
  }
};
</script>
